import { Vue, Component, Ref } from 'vue-property-decorator'
import { CreateElement } from 'vue'
import { MainSliderAdvertisementItem } from '~/types/api/MainSliderAdvertisementItem'
import ContraindicationsSvg from '~/assets/svg/contraindications.svg?inline'
import ContraindicationsMobileSvg from '~/assets/svg/contraindicationsMobile.svg?inline'
import BadSvg from '~/assets/svg/bad.svg?inline'
import BadMobileSvg from '~/assets/svg/bad-mobile.svg?inline'
import MainSliderRequiredTextType from '~/types/enum/MainSliderRequiredTextType'
import Slider from '~/components/block/Slider'
import SectionHelper from '~/utils/sectionHelper'
import s from '~/utils/s'
import general from '~/store/general'
import mainPage from '~/store/mainPage'
import MarkingAd from '~/components/element/MarkingAd'
import Preloader from '~/components/element/Preloader'

const requiredTextSvg = {
  [MainSliderRequiredTextType.Contraindications]: {
    desktop: ContraindicationsSvg,
    mobile: ContraindicationsMobileSvg
  },
  [MainSliderRequiredTextType.Bad]: {
    desktop: BadSvg,
    mobile: BadMobileSvg
  }
}

@Component({
  components: {
    Slider
  }
})
export default class MainSliderAdvertisement extends Vue {
  generalStore: general
  mainPage: mainPage
  constructor () {
    super()
    this.generalStore = s(this.$store).general
    this.mainPage = s(this.$store).mainPage
  }

  @Ref()
  readonly slider!: Slider

  currentSlide: number = 0

  startMoveClickSlider: number = 0
  endMoveClickSlider: number = 0

  get items () {
    return this.mainPage?.mainSliderAdvertisementItems
  }

  get count (): number {
    return this.items?.length ?? 0
  }

  change (index: number) {
    this.currentSlide = index
  }

  next () {
    this.slider.next()
  }

  prev () {
    this.slider.prev()
  }

  renderRequiredTextBlock (h: CreateElement, item: MainSliderAdvertisementItem) {
    if (item.requiredTextCode && requiredTextSvg[item.requiredTextCode]) {
      return (
        <div class="main-slider-advertisement__contraindications-block">
          <div class="main-slider-advertisement__contraindications-block-desktop">
            {h(requiredTextSvg[item.requiredTextCode].desktop)}
          </div>
          <div class="main-slider-advertisement__contraindications-block-mobile">
            {h(requiredTextSvg[item.requiredTextCode].mobile)}
          </div>
        </div>
      )
    }
  }

  getStyleBackground (item: MainSliderAdvertisementItem) {
    if (item.img !== undefined) {
      return `background-image: url("${item.img.d}")`
    }
    return ''
  }

  mouseDown (offsetX: number) {
    this.startMoveClickSlider = offsetX
  }

  mouseMove (offsetX: number) {
    this.endMoveClickSlider = offsetX
  }

  mouseUp (e: MouseEvent, item: MainSliderAdvertisementItem) {
    if (Math.abs(this.startMoveClickSlider - this.endMoveClickSlider) > 20) {
      e.preventDefault()
    } else if (item.link && item.link.length > 0) {
      if (item.link.includes('24farmacia.ru')) {
        this.$router.push(item.link.split('24farmacia.ru')[1])
      } else if (item.link.match(/^(http|https):\/\//i)) {
        window.location.href = item.link
      } else {
        this.$router.push('/' + item.link)
      }
    } else if (item.promotionCode && item.promotionCode.length > 0) {
      this.$router.push({ name: 'region-stock-code', params: { code: item.promotionCode } })
    } else if (item.categoryId && item.categoryId.length > 0) {
      const helper = new SectionHelper(this.generalStore.sections, this.$store)
      const link = helper.getSectionPathById(item.categoryId) ?? ''
      this.$router.push(link)
    } else if (item.productListId && item.code && item.code.length > 0) {
      this.$router.push({ name: 'region-banner-code', params: { code: item.code } })
    }
  }

  renderItem (h: CreateElement, item: MainSliderAdvertisementItem) {
    if (this.items && this.count > 0) {
      return (
        <div class="main-slider-advertisement__item-wrapper">
          <MarkingAd {...{
            props: {
              info: item.marking
            }
          }} />

          <div class="main-slider-advertisement__item" style={this.getStyleBackground(item)}
            ondragstart={(e: Event) => {
              e.preventDefault()
            }} onmousedown={(e: MouseEvent) => {
              this.mouseDown(e.screenX)
            }} onmousemove={(e: MouseEvent) => {
              this.mouseMove(e.screenX)
            }} onmouseup={(e: MouseEvent) => {
              this.mouseUp(e, item)
            }}
          >
            <div domPropsInnerHTML={item.bannerText} class="main-slider-advertisement__item-title" />
            {this.renderRequiredTextBlock(h, item)}
          </div>
        </div>
      )
    }
  }

  renderDot (index: number) {
    return (
      <div {...{
        on: {
          click: () => this.slider.moveTo(index)
        },
        class: {
          'main-slider__nav-dots-item': true,
          'main-slider__nav-dots-item_selected': index === this.currentSlide
        }
      }}></div>
    )
  }

  render (h: CreateElement) {
    return (
      <div class="main-slider-advertisement">
        <div class="main-slider-advertisement__track">
          {this.items && this.count > 0 ? this.items.map((e: MainSliderAdvertisementItem) => this.renderItem(h, e))
            : <div class="main-slider-advertisement__item-wrapper">
              <div class="main-slider-advertisement__item main-slider-advertisement__item__preloader">
                <Preloader/>
              </div>
            </div>}
        </div>
        <div class="main-slider-advertisement__nav">
          <div class="main-slider-advertisement__nav-prev" onClick={this.prev}>
          </div>
          <div class="main-slider-advertisement__nav-dots">
            {this.items ? this.items.map((e: MainSliderAdvertisementItem, i: number) => this.renderDot(i)) : ''}
          </div>
          <div class="main-slider-advertisement__nav-next" onClick={this.next}>
          </div>
        </div>
      </div>
    )
  }
}
